import YouTubePlayer from 'youtube-player';
import 'intersection-observer';

import $ from 'jquery';

class VideoPlayer {
    constructor(videoElement) {
        this.$body = $('body');
        this.$window = $(window);
        this.videoElement = videoElement;
        this.$videoElement = $(videoElement);
        this.$videoContainer = this.$videoElement.closest('.video');

        this.init();
        this.events();
    }

    init() {
        this.videoId = this.$videoElement.data('id');
        this.player = YouTubePlayer(this.videoElement, {
            videoId: this.videoId,
            playerVars: {
                showinfo: 0,
                rel: 0
            }
        });

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    this.$body.trigger('video-pause', [this.player]);
                }
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0
        });

        this.observer.observe(this.$videoContainer[0]);
    }

    events() {
        this.player.on('stateChange', event => {
            if (event.data === YT.PlayerState.PLAYING) {
                this.$body.trigger('video-play', [this.player]);
            }
        });

        this.$body.on('video-pause', (e, player) => {
            if (this.player === player)
                this.player.pauseVideo();
        });

        this.$body.on('video-play', (e, player) => {
            if (this.player !== player)
                this.player.pauseVideo();
        });

        this.$videoContainer.on('click', '.video-play', () => {
            this.$body.trigger('video-play', [this.player]);

            this.$videoContainer.addClass('playing');
            this.player.playVideo();
        });

        this.$body.on('layer-closed', () => {
            this.player.stopVideo();
        });

        this.$body.on('layer-open', (e, layer) => {
            if (this.$videoContainer.closest('.layer').is($(layer))) {
                this.player.playVideo();
            }
        });
    }
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./sources/js/components/video-player.js